import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Database, Download, Loader2, CheckCircle } from 'lucide-react';

export default function ExportDbPage() {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const response = await api.get('/db/export', { responseType: 'blob' });
      const filename = response.headers['content-disposition']
        ?.match(/filename="(.+)"/)?.[1] || `sios_export_${Date.now()}.zip`;
      const url = window.URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Export completato');
    } catch (err) {
      console.error('Export error:', err);
      toast.error('Errore durante l\'export');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="space-y-8" data-testid="export-db-page">
      <div>
        <h1 className="font-heading text-3xl font-bold">Export Database</h1>
        <p className="text-muted-foreground mt-1">Scarica un backup completo del database</p>
      </div>

      <div className="glass rounded-xl p-8 max-w-lg space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center">
            <Database size={24} className="text-primary" />
          </div>
          <div>
            <h2 className="font-medium text-lg">Backup completo</h2>
            <p className="text-sm text-muted-foreground">Edizioni, eventi, speaker, sessioni, track, gallerie, settings, redirect, newsletter</p>
          </div>
        </div>

        <Button
          onClick={handleExport}
          disabled={exporting}
          className="w-full"
          size="lg"
          data-testid="export-db-btn"
        >
          {exporting ? (
            <><Loader2 size={18} className="mr-2 animate-spin" /> Esportazione in corso...</>
          ) : (
            <><Download size={18} className="mr-2" /> Scarica Export ZIP</>
          )}
        </Button>

        <p className="text-xs text-muted-foreground text-center">Il file ZIP contiene un JSON per ogni collezione del database</p>
      </div>
    </div>
  );
}
